import Header from './components/Header';
import Hero from './components/Hero';
import { HotRanking, DeepArchive } from './components/HotDeep';
import { ClueTimeline, Contradictions } from './components/Clue';
import { Categories } from './components/Categories';
import { Guide } from './components/Guide';
import { Faq } from './components/Faq';
import { About } from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <HotRanking />
        <DeepArchive />
        <ClueTimeline />
        <Contradictions />
        <Categories />
        <Guide />
        <About />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}